import api from './api';

const userService = {
  updateProfile: (data) => api.put('/users/profile', data),
  getLoyaltyPoints: () => api.get('/users/loyalty-points'),
  redeemPoints: (points) => api.post('/users/loyalty-points/redeem', { points }),
};

export default userService;
